import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "icon"]
  static values = {
    open: { type: Boolean, default: false },
    expanded: { type: Boolean, default: false }
  }

  connect() {
    // Support both 'open' and 'expanded' value names
    if (this.expandedValue) {
      this.openValue = true
    }
    this.updateDisplay()

    // Watch for content changes to update height
    if (this.hasContentTarget) {
      this.observer = new MutationObserver(() => this.recalculateHeight())
      this.observer.observe(this.contentTarget, { childList: true, subtree: true })
    }
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect()
    }
  }

  toggle() {
    this.openValue = !this.openValue
  }

  expand() {
    this.openValue = true
  }

  collapse() {
    this.openValue = false
  }

  openValueChanged() {
    this.updateDisplay()
  }

  recalculateHeight() {
    if (this.openValue && this.hasContentTarget) {
      this.contentTarget.style.maxHeight = this.contentTarget.scrollHeight + "px"
    }
  }

  updateDisplay() {
    if (this.hasContentTarget) {
      if (this.openValue) {
        this.contentTarget.style.maxHeight = this.contentTarget.scrollHeight + "px"
      } else {
        this.contentTarget.style.maxHeight = "0"
      }
    }
    if (this.hasIconTarget) {
      this.iconTarget.classList.toggle("rotate-180", this.openValue)
    }
  }
}